import { useLocation, useNavigate } from 'react-router-dom'
import { KeyRound } from 'lucide-react'
import { useIsAuthenticated, useTokenValid } from '@/core/auth/SessionStore'

/**
 * Faixa no topo quando o token venceu (JWT 12h) mas a sessão local continua.
 *
 * O app é offline-first: token vencido NÃO derruba o operador para o login —
 * no campo, sem sinal, ele não conseguiria entrar de novo e perderia o acesso
 * aos catálogos e aos rascunhos. Ele continua lançando (tudo fica no outbox) e
 * só precisa entrar de novo, quando tiver rede, para os envios saírem.
 */
export function ReauthBanner() {
  const authed = useIsAuthenticated()
  const tokenValid = useTokenValid()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  if (!authed || tokenValid || pathname === '/login') return null

  return (
    <div className="sticky top-0 z-40 bg-bg-elevated border-b border-warn/40">
      <div className="max-w-2xl mx-auto px-3 py-2 flex items-center gap-2 text-xs">
        <KeyRound className="h-4 w-4 shrink-0 text-warn" aria-hidden />
        <p className="flex-1 min-w-0 text-on-surface">
          <span className="font-semibold">Sessão expirada.</span>{' '}
          <span className="text-on-surface-dim">Continue lançando; entre de novo com internet para enviar.</span>
        </p>
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="h-8 px-3 rounded-md bg-warn text-black font-semibold shrink-0"
        >
          Entrar
        </button>
      </div>
    </div>
  )
}
